import React from 'react';
import { CreditCard } from 'lucide-react';
import { PAYMENT_MODE_BADGE_STYLES } from '../Salary/salaryTheme';

export default function PaymentModeBadge({ mode }) {
  const m = mode || 'Cash';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[11px] font-semibold ring-1 ring-inset ${
        PAYMENT_MODE_BADGE_STYLES[m] || PAYMENT_MODE_BADGE_STYLES.Other
      }`}
    >
      <CreditCard className="h-3 w-3 opacity-70" aria-hidden />
      {m}
    </span>
  );
}
